import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import {
   CallDirectionTypes,
   CallDispositionTypes,
   CallRetentionPolicyTypes,
   OrderingOption,
   Providers,
} from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.service';
import { setHideRecordingDate } from 'src/app/common-components/helpers/call-logs-helper';
import { getProviderDisplayName } from 'src/app/common-components/helpers/provider-helper';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { AccountDetailApiService } from 'src/app/pages/account-details/services/account-detail-api.service';
import { ListenToRecordingModel } from 'src/app/pages/call-logs-register/state/call-logs-register.actions';
import { FileOption } from 'src/app/pages/prompt-details/models/file.option.interface';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ActiveCallsRegisterOptions } from '../../models/active-calls-register-options';
import { ActiveCallsRegisterListItem } from '../../models/active-calls-register-results.model';
import { CallRecordingsPrivileges, LCSCallRecordingsPrivileges } from '../../models/call-recordings-privileges';
import { HangUpCallsPrivileges } from '../../models/hang-up-calls.privileges';
import { ActiveCallsRegisterApiService } from '../../services/active-calls-register-api.service';
import { selectQuickFilters } from '../../state/account-call-history/account-call-history.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-account-call-history-register-view',
   styleUrls: ['./account-call-history-register-view.component.scss'],
   templateUrl: './account-call-history-register-view.component.html',
   standalone: false,
})
export class AccountCallHistoryRegisterViewComponent extends EntityRegisterView<
   ActiveCallsRegisterListItem,
   ActiveCallsRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => ActiveCallsRegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() hangupActiveCallsPrivileges: HangUpCallsPrivileges;

   @Input() callRecordingsPrivileges: CallRecordingsPrivileges;

   @Input() callRecordingsLCSPrivileges: LCSCallRecordingsPrivileges;

   @Input() isSystemUser: boolean;

   @Output() openDialog = new EventEmitter<{ callLogs: ActiveCallsRegisterListItem }>();

   @Output() listen = new EventEmitter<ListenToRecordingModel>();

   callRetentionPolicyTypeId: CallRetentionPolicyTypes | null;

   hideRecordingDate: string;

   currentAccount$: Observable<number | null>;

   formatProvider = getProviderDisplayName;

   constructor(
      public store: Store,
      private accountDetailApiService: AccountDetailApiService,
      private activeCallsApiService: ActiveCallsRegisterApiService,
      private dialogService: ConfirmationDialogService
   ) {
      super(store);
      this.currentAccount$ = store.select(getSelectedAccountId);
      this.currentAccount$
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            })
         )
         .subscribe((accountId: number) => {
            this.fetchAccountDetails(accountId);
         });
   }

   onOpenDialog(callLogs: ActiveCallsRegisterListItem) {
      this.openDialog.emit({ callLogs: callLogs });
   }

   onListen(callLogs: ActiveCallsRegisterListItem) {
      let callRecordingFiles: Array<FileOption> = [];
      this.activeCallsApiService.getCallDetailDialogData(callLogs.callDetailId).subscribe((result) => {
         const callRecordingFile = result.data?.callDetail.callRecording?.file;
         if (callRecordingFile) {
            callRecordingFiles = [...callRecordingFiles, callRecordingFile];
            this.listen.emit({
               callRecordingId: callLogs.callRecordingId,
               files: callRecordingFiles,
            });
         }
      });
      //get file by callrecording id

      // if (callLogs.callRecordingCallDetailsConnection?.items){
      //    callLogs.callRecordingCallDetailsConnection?.items.forEach(value => {
      //       if(value.callRecording.file){
      //          let tempFile : FileOption = {
      //             fileId: value.callRecording.file.fileId,
      //             fileName: value.callRecording.file.fileName,
      //             fileToken: value.callRecording.file.fileToken,
      //          };
      //          callRecordingFiles.push(tempFile);
      //       }
      //    })
      // }
   }

   getRouterLink(id: number) {
      return '';
   }

   onFilterChange(filterValues: {
      startDate: Date | null;
      endDate: Date | null;
      fromDuration: number;
      toDuration: number;
      callDisposition: CallDispositionTypes;
      callDirection: CallDirectionTypes;
      extensionGroupExtensions: number[];
      providerId: Providers;
   }): void {
      const {
         startDate,
         endDate,
         fromDuration,
         toDuration,
         callDisposition,
         callDirection,
         extensionGroupExtensions,
         providerId,
      } = filterValues;
      this.registerOptions = {
         ...this.registerOptions,
         duration: fromDuration ?? toDuration,
         endDate: endDate ?? undefined,
         startDate: startDate ?? undefined,
         callDisposition,
         callDirection,
         extensionGroupExtensions,
         providerId,
      };
      this.quickFilterChange.emit(this.registerOptions);
   }

   fetchAccountDetails(accountId: number): void {
      this.accountDetailApiService
         .getAccountDetails(accountId)
         .pipe(take(1))
         .subscribe((result) => {
            if (result.data) {
               this.callRetentionPolicyTypeId = result.data.account.callRetentionPolicyTypeId;
               this.hideRecordingDate = setHideRecordingDate(this.callRetentionPolicyTypeId);
            }
         });
   }
}
